import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import SubadminListTopbar from "../../features/manageSubAdmin/topbar";

const ManageSubadmin = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [limit] = useState(10);

    // Debounce search term
    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
            setPage(1); // Reset to page 1 when search changes
        }, 500);

        return () => {
            clearTimeout(timerId);
        };
    }, [searchTerm]);

    const onPageChange = (newPage: number) => {
        const totalPages = Math.ceil(100 / limit); // This will be calculated from API response
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className="main_title">
                <h1>Manage Sub-Admin</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Sub-Admin
                </p>
            </div>

            <div className="cards">
                <SubadminListTopbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                <SubadminList
                    searchTerm={debouncedSearchTerm}
                    page={page}
                    limit={limit}
                    onPageChange={onPageChange}
                    setPage={setPage}
                />
            </div>
        </>
    );
};

export default ManageSubadmin;
